import { render, staticRenderFns } from "./SideBarParticipants.vue?vue&type=template&id=7def639a&"
import script from "./SideBarParticipants.vue?vue&type=script&lang=js&"
export * from "./SideBarParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports